// Google Analytics 4 (gtag.js) helpers.
// The gtag base snippet is loaded in client/index.html with `send_page_view: false`,
// so we send page_view events manually on each client-side route change.

export const GA_MEASUREMENT_ID = "G-NDNNJH04WG";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

/** Send a page_view for the current location. Call on every route change. */
export function trackPageView(path: string): void {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
    send_to: GA_MEASUREMENT_ID,
  });
}

/** Send a custom event to GA4. */
export function trackEvent(
  action: string,
  params: Record<string, unknown> = {}
): void {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", action, params);
}
